import styled, { css } from 'styled-components'

export const ThankYouPageWrapper = styled.div`
  ${({ theme, isAlternativeActive }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 15rem;
    background-color: ${theme.colors.light};
    padding: 2rem 1rem;
  `}
`

export const ThankYouPageIconContainer = styled.div`
  ${({ theme }) => css`
    margin: 1rem;

    .prefix__a {
      stroke: ${theme.colors.primary.default};
    }

    @media (min-width: ${theme.ToRem(480)}) {
      margin: 1rem 1rem 2rem;
    }
  `}
`

export const ThankYouPageTitleContainer = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.ToRem(18)};
    text-align: center;
    margin-bottom: 2rem;
    line-height: 1.5;
  `}
`

export const ThankYouPageSubtitleContainer = styled.div`
  ${({ theme }) => css`
    text-align: center;
    line-height: 1.5;
    font-size: ${theme.ToRem(18)};
  `}
`
